import { TextField, Typography } from '@mui/material';
// import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import LoadingShort from '../../../../load/loadingShort';
import RegisterAccess from '../../../../utils/registerAccess';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

const ReenviarEmail = (props) => {
    // const [open, ] = useState(props.load);

    const handleClose = () => {
        props.setOpenReenviarEmail(false);
    };

    return (
        <>
         <RegisterAccess page={'reenviar email'}/>
            <BootstrapDialog
                scroll='body'
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={props.openReenviarEmail}
            >
                <div className="tw-p-5 md:tw-p-6">

                    <Typography>
                        <strong>Enviar por e-mail</strong>
                        <br />
                        <small>OBS: pode mudar o email</small>
                    </Typography>

                    <TextField
                        fullWidth
                        type='email'
                        size='small'
                        defaultValue={props.estabelecimento?.email?.toLowerCase()}
                        onChange={(e) => props.setNovoEmail(e.target.value)}
                    />

                    <div className="tw-mt-4 tw-flex tw-flex-wrap tw-justify-end tw-gap-2">
                        <button
                            type="button"
                            onClick={handleClose}
                            disabled={props.load}
                            className="tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-transition hover:tw-bg-slate-50 disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={() => props.generatePDF('Enviando_email', props.autorizacao)}
                            disabled={props.load}
                            className="tw-inline-flex tw-min-w-[110px] tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#85287e] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition hover:tw-brightness-110 disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
                        >
                            {props.load ? <LoadingShort /> : 'Enviar'}
                        </button>
                    </div>
                    {/* } */}
                </div>
            </BootstrapDialog>
        </>
    );
}

export default ReenviarEmail;
